export const HOST = 'https://dansu-api.hocluat.xyz'